<a [href]="url" target="_blank" fxLayout="row" fxLayoutAlign="start center"
	class="link-to-yt cursorPointer font-family-raleway ca-font-weight-900">
	<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M35.9814 12.6235C12.3148 12.6235 9.35645 15.5819 9.35645 36.2902C9.35645 56.9985 12.3148 59.9569 35.9814 59.9569C59.6481 59.9569 62.6064 56.9985 62.6064 36.2902C62.6064 15.5819 59.6481 12.6235 35.9814 12.6235ZM44.8564 36.8819L30.6564 45.1652C30.3606 45.461 29.7689 45.1652 29.7689 44.5735V28.0069C29.7689 27.4152 30.0648 27.1194 30.6564 27.4152L44.8564 35.6985C45.4481 35.9944 45.4481 36.586 44.8564 36.8819Z"
			stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
	<div *ngIf="!hideText">
		Learn about <br>
		{{name}}
	</div>
</a>